import { render } from "./ARpage.vue?vue&type=template&id=1f991ad0&scoped=true"
import script from "./ARpage.vue?vue&type=script&lang=js"
export * from "./ARpage.vue?vue&type=script&lang=js"

import "./ARpage.vue?vue&type=style&index=0&id=1f991ad0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f991ad0"]])

export default __exports__